<div class="form form--date-long form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label></basic-label>
  </div>
  <div class="form__field">
    <basic-text-input
      #textInputComponent
      [propertyName]="questionItem.prop"
      [placeholder]="questionItem.placeholder"
      [parserType]="'Date'"
      [formatterType]="'date_mmddyyyy'"
      [disableConditionally]="disableConditionally"
      [inputMask]="mask"
    ></basic-text-input>
  </div>
</div>
